module.exports = __webpack_public_path__ + "img/nutrieon-diazon-83x113.5ebe5eb8.png";